<template>
  <div>
    <!-- toasts message -->
    <v-card color="grey lighten-4">
      <v-snackbar :timeout="timeout" :color="color" :left="left" v-model="snackbar">{{ message }}</v-snackbar>
    </v-card>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->
    
    <v-btn color="primary" dark slot="activator" class="mb-2" @click="addNew">Add New</v-btn>

    <v-card-title>
      <h2>Loan Profile</h2>
      <v-spacer></v-spacer>
      <!-- <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field> -->

            <!-- <v-text-field class="ma-1" label="Loan Number" single-line hide-details v-model="searchField.loan_no"></v-text-field> -->
            <!-- :items="['IPFF/POWER/PFI 1/0533','IPFF I/Water/DBBL/0527']"   -->
            <v-autocomplete            
            label="Loan Number"
            item-text="loan_no"
            item-value="loan_no"
            v-model="searchField.loan_no"            
            :items="loanNoList" 
            clearable
            single-line hide-details         
            ></v-autocomplete>

            <v-text-field class="ma-1" label="Reschedule No" single-line hide-details v-model="searchField.re_schedule_no"></v-text-field>

            <v-text-field class="ma-1" label="Reset No" single-line hide-details v-model="searchField.reset_no"></v-text-field>

            <v-btn color="success" single-line hide-details @click="searhByVal">
              <v-icon>search</v-icon>
            </v-btn>

    </v-card-title>

    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-left">{{ props.item.loan_no }}</td>        
        <td class="text-xs-left">{{ props.item.re_schedule_no }}</td>
        <td class="text-xs-left">{{ props.item.reset_no }}</td>
        <td class="text-xs-left">{{ props.item.sub_project_name }}</td>
        <td class="text-xs-left">{{ props.item.loan_amount }}</td>
        <td class="text-xs-left">{{ props.item.loan_period_in_month }}</td>
        <td class="text-xs-left">{{ props.item.transaction_currency }}</td>
        <td class="text-xs-left" v-html="getStatus(props.item.status)">   
        </td>

        <td class="justify-center layout px-0">
          <template v-if="props.item.status == 1">
          <v-btn title="View" icon class="mx-0" @click="viewDetail(props.item)" v-if="props.item.loan_date != '0000-00-00'">
            <v-icon color="teal">list</v-icon>
          </v-btn>
          <v-btn title="Edit" icon class="mx-0" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn title="Delete" icon class="mx-0" @click="deleteItem(props.index, props.item.id)" v-if="props.item.loan_date == '0000-00-00'">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
          </template>

          <template v-else>
            <v-btn title="View" icon class="mx-0" @click="viewDetail(props.item)">
            <v-icon color="teal">list</v-icon>
          </v-btn>
           <!-- <v-btn title="Detail" icon class="mx-0" @click="viewDetail(props.item)">
            <v-icon color="teal">list</v-icon>
          </v-btn> -->
          </template>

        </td>
      </template>
    </v-data-table>
  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import Repayment from './repayment';

import Axios from "axios";
import {mapActions} from 'vuex'
export default {
  components:{
    Repayment,
  },

  data: () => ({
    valid: true,

    loanNoList:[],
    searchField:{
      loan_no:'',
      re_schedule_no:'',
      reset_no:'',
    },

    selected: [],

    delete_id: "",
    row_index: "",
    dialog2: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",

    select: null,
    typelist: [
      { name: "Type 1", id: 1 },
      { name: "Type 2", id: 2 },
      { name: "Type 3", id: 3 }
    ],

    formSchema: {
      id: 0,
      doner_no: "",
      doner_name: "",
      doner_type: "",
      in_short: ""
    },

    /*############# Datatable #############*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      {
        text: "SL",
        value: ""
      },
      {
        text: "Loan Number",
        align: "left",
        sortable: true,
        value: "loan_no"
      },
      {
        text: "Re Schedule No",
        align: "left",
        sortable: true,
        value: "re_schedule_no"
      },
      {
        text: "Reset No",
        align: "left",
        sortable: true,
        value: "reset_no"
      },
      {
        text: "Sub Project Name",
        align: "left",
        sortable: true,
        value: "sub_project_name"
      },
      {
        text: "Loan Amount",
        align: "left",
        sortable: true,
        value: "loan_amount"
      }, 
      {
        text: "Loan Period(In Month)",
        align: "left",
        sortable: true,
        value: "loan_period_in_month"
      }, 
      {
        text: "Currency",
        align: "left",
        sortable: true,
        value: "transaction_currency"
      }, 
      {
        text: "Status",
        align: "left",
        sortable: true,
        value: "status"
      }, 
     /* {
        text: "PFI Name",
        align: "left",
        sortable: true,
        value: "short_name"
      }, 
      {
        text: "Client Name",
        align: "left",
        sortable: true,
        value: "client_name"
      }, 
      {
        text: "Sector",
        align: "left",
        sortable: true,
        value: "sector_name"
      },*/
      
      { text: "Action", align: "center", value: "" }
    ]
    /*############# /Datatable #############*/
  }),

  created(){    
    //commonService.getAllData("get-dis-dropdown-data").then(res => {        
    commonService.getAllData("get-loan-number-list").then(res => {        
      this.loanNoList = res.loanNoList;
    });
  },

  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {          
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    }
  },

  methods: {
   ...mapActions(['currentLoanProfile']),
    searhByVal()
    {
      this.getDataFromApi().then(data => {          
        this.desserts = data.items;
        this.totalDesserts = data.total;
      });
    },

    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),

          (query_Data.loan_no = (this.searchField.loan_no) ? this.searchField.loan_no : ''),
          (query_Data.re_schedule_no = this.searchField.re_schedule_no),
          (query_Data.reset_no = this.searchField.reset_no),

          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "loan-profile-list")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    getStatus(status){
      let sts = [
          {'id':'1', 'title':'<span class="success--text">Active</span>'},
          {'id':'2', 'title':'<span class="primary--text px-1">Execute</span>'},
          {'id':'3', 'title':'<span class="error--text px-1">Reset</span>'},
          {'id':'4', 'title':'<span class="into--text px-1">Re-Schedule</span>'}, 
          {'id':'5', 'title':'<span class="deep-orange--text px-1">Close</span>'}, 
          {'id':'6', 'title':'<span class="blue-grey--text px-1">Terminate</span>'},
          {'id':'7', 'title':'<span class="brown--text px-1">Settlement</span>'},        
    ];
    if(status>0){
      return sts.filter(function(a){
        return a.id == status;
      })[0].title;
    }
    else
    {
      return '';
    }
    
    
    },

    editItem(index, item) {
      this.row_index = index;
      this.formSchema = item;
      sessionStorage.setItem("loan_id", item.id);      
      sessionStorage.setItem("reset_no", item.reset_no);      
      sessionStorage.setItem("re_schedule_no", item.re_schedule_no);      
      this.$store.commit('SET_KEY_VALUE', item.total_disburs);
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
      this.$router.push("/on-lending/loan-profile-stepform");
    },

    addNew() {
      this.remove_session();
      this.$store.commit('UNSET_KEY_VALUE');
      this.$store.commit('UNSET_COMMON_DATA');
      this.$router.push("/on-lending/loan-profile-stepform");
    },

    viewDetail(items){
      this.currentLoanProfile(items)
      this.$store.commit('SET_COMMON_DATA',items);
      this.$router.push("/on-lending/loan-profile-detail");
    },
    viewReSchedule (items) {
      sessionStorage.setItem("loan_id", items.id);      
      this.currentLoanProfile(items)
      this.$store.commit('SET_COMMON_DATA',items);
      this.$router.push("/on-lending/loan-re-schedule-detail");

    },

    remove_session() {
      sessionStorage.removeItem("loan_id");
      sessionStorage.removeItem("loan_s");
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      
      commonService.deleteRow(id, "loan-profile").then(res => {
        if (res.status == 1) {
          //this.items.splice(row_index, 1);
          //commonService.getAllData("get-dis-dropdown-data").then(res => {        
          this.getDataFromApi();
          this.message = res.message;
          this.snackbar = true;
          this.confirmModel = false;
          this.dialog2 = false;
          this.remove_session();
          this.getDataFromApi();
        } else {
          this.message = "Try again!";
          this.snackbar = true;
        }
      });
    },

    close(res) {
      if (res.action == "add") {
        this.items.push(res.data);
      }
      if (res.action == "edit") {
        this.items[this.row_index] = res.data;
      }

      this.message = res.message;
      this.snackbar = true;
      this.row_index = "";
    }
  }
};
</script>
<style scoped>
table.v-table thead th:not(:nth-child(1)){
  padding: 0 6px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/lending/loanProfile/dataTable.vue